import useCEP from './useCEP';

export default useCEP;
